export default "__VITE_ASSET__cf766ec8__"